export class TermModel {
    id: number;
    description: string;
    isBold: boolean;
    createDate: Date;
    lastUpdate: Date;
    isDeleted: boolean;
    creatorID: number;
    updatorID: number;
    serviceTypeID: number;
    serviceType: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/term.model.ts